export const MODAL_DESCRIPTION =
  'It can take several minutes before the documents will appear here. You will need to refresh your browser in a little while.';
